export type TemplateTier = 'mini' | 'evening' | 'extended' | 'compressed' | 'full'

export interface DayTemplate {
  tier: TemplateTier
  flowSlots: number
  label: string
}

export const TEMPLATES: Record<TemplateTier, DayTemplate> = {
  mini: { tier: 'mini', flowSlots: 2, label: 'Mini gün' },
  evening: { tier: 'evening', flowSlots: 4, label: 'Akşam günü' },
  extended: { tier: 'extended', flowSlots: 8, label: 'Uzatılmış gün' },
  compressed: { tier: 'compressed', flowSlots: 7, label: 'Kısaltılmış gün' },
  full: { tier: 'full', flowSlots: 11, label: 'Tam gün' },
}

const ORDER: TemplateTier[] = ['mini', 'evening', 'extended', 'compressed', 'full']

export function tierForMinutes(mins: number): TemplateTier {
  if (mins >= 480) return 'full'
  if (mins >= 330) return 'compressed'
  if (mins >= 180) return 'evening'
  return 'mini'
}

export function templateFor(mins: number, isWeekend: boolean): DayTemplate {
  const base = tierForMinutes(mins)
  if (!isWeekend) return TEMPLATES[base]
  if (base === 'full') return TEMPLATES.full
  const idx = ORDER.indexOf(base)
  return TEMPLATES[ORDER[Math.min(idx + 1, ORDER.length - 2)]]
}

export function minDayTemplate(): DayTemplate {
  return { tier: 'mini', flowSlots: 4, label: 'Minimum gün' }
}

export const PART_LABELS = ['🌅 Sabah', '☀️ Öğleden sonra', '🌙 Akşam'] as const

export function partSizes(n: number): number[] {
  if (n <= 3) return [n]
  if (n === 4) return [2, 2]
  if (n <= 6) return [2, 2, n - 4]
  if (n <= 8) return [3, 3, n - 6]
  return [4, 4, n - 8]
}
